










import { Component, Prop, Vue } from 'vue-property-decorator';
import { TabbedContentBlockViewModel } from '@/types/contentServerContract';
import Tabs from '@/core/ui-components/tabs/Tabs.vue';
import Tab from '@/core/ui-components/tabs/Tab.vue';

@Component({
    components: { Tabs, Tab }
})
export default class TabbedContentBlock extends Vue {
    @Prop({ required: true, type: Object })
    private content!: TabbedContentBlockViewModel;
}
